var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7779 13.8891C18.4526 13.8891 19.0189 14.446 18.9158 15.1123C18.3105 19.0323 14.9547 21.9428 10.9074 21.9428C6.42946 21.9428 2.79999 18.3134 2.79999 13.8365C2.79999 10.1481 5.60209 6.7123 8.75683 5.93546C9.43472 5.76809 10.1295 6.24493 10.1295 6.94283C10.1295 11.6712 10.2884 12.8944 11.1863 13.5597C12.0842 14.2249 13.14 13.8891 17.7779 13.8891Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1925 9.95157C22.2462 6.91368 18.5146 2.01684 13.9672 2.10105C13.6136 2.10736 13.3304 2.4021 13.3146 2.75473C13.1999 5.25263 13.3546 8.48947 13.4409 9.95684C13.4672 10.4137 13.8262 10.7726 14.282 10.7989C15.7904 10.8853 19.1451 11.0032 21.6072 10.6305C21.942 10.58 22.1872 10.2895 22.1925 9.95157Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmpty);
export default __webpack_public_path__ + "static/media/dashboard_empty.b550c1fc313f416f39e55e93f215739f.svg";
export { ForwardRef as ReactComponent };